import { useEffect, useMemo } from 'react';

import { useRerender } from '@hooks/useRerender';
import { IStack, Stack } from '@lib/Stack';

export function useStack<T>(
  initialItems: T[] = [],
  deps: T[],
  isEqual: (a: T, b: T) => boolean,
): IStack<T> {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stack = useMemo(() => new Stack<T>(initialItems), []);
  const rerender = useRerender();

  useEffect(() => {
    const pushUnsubscribe = stack.subscribe('push', rerender);
    const popUnsubscribe = stack.subscribe('pop', rerender);
    const updateUnsubscribe = stack.subscribe('update', rerender);

    return (): void => {
      pushUnsubscribe();
      popUnsubscribe();
      updateUnsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    stack.update(deps, isEqual);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return stack;
}
